var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankidLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_401",
    "data-name": "Group 401",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.159,
    height: 52.155,
    viewBox: "0 0 55.159 52.155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 55.159,
    height: 52.155,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M27.886,49.169l2.3-14.522H27.729a3.337,3.337,0,0,1-3.072-1.833c-.14-.4-.471-1.78,1.431-3.124a2.8,2.8,0,0,0,1.2-1.4,1.084,1.084,0,0,0-.314-1.065,3.41,3.41,0,0,0-2.287-.628c-1.763,0-3,1.012-3.124,1.745a1.413,1.413,0,0,0,.7,1.257,2.228,2.228,0,0,1,.681,3.124,4.557,4.557,0,0,1-3.84,1.92H16.592c-.209,1.414-3.631,23.093-3.892,24.8H26.28c.122-.751.751-4.852,1.606-10.281",
    transform: "translate(-10.483 -21.957)",
    fill: "#2c6d8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M1.484,243.6H7.052c2.374,0,2.95,1.2,2.775,2.3a2.623,2.623,0,0,1-1.8,1.99,2.135,2.135,0,0,1,1.658,2.531,3.262,3.262,0,0,1-3.351,2.705H0Zm3.683,3.945a1.507,1.507,0,0,0,1.693-1.257c.1-.733-.227-1.239-1.309-1.239h-.96l-.384,2.5Zm-.593,4.1c1.117,0,1.763-.454,1.92-1.379.122-.8-.332-1.274-1.414-1.274H4l-.419,2.671h.995Z",
    transform: "translate(0 -201.08)",
    fill: "#2c6d8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M66.569,262.775c-1.449.1-2.147-.052-2.5-.681a4.784,4.784,0,0,1-2.531.716c-1.641,0-2.217-.855-2.06-1.8a2.133,2.133,0,0,1,.751-1.257c.908-.785,3.142-.89,4.015-1.484.07-.663-.192-.908-1.012-.908a5.3,5.3,0,0,0-3.142,1.257l.332-2.164a6.014,6.014,0,0,1,3.666-1.257c1.693,0,3.194.7,2.915,2.548l-.332,2.095c-.122.733-.087.96.733.977Zm-2.513-3.3c-.768.489-2.2.4-2.356,1.414a.674.674,0,0,0,.7.82,2.75,2.75,0,0,0,1.466-.506,1.911,1.911,0,0,1,.035-.681Z",
    transform: "translate(-49.079 -210.655)",
    fill: "#2c6d8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M110.335,255.322h2.9l-.157.96a3.639,3.639,0,0,1,2.531-1.082c1.623,0,2.374.995,2.112,2.618l-.751,4.87h-2.9l.628-4.032c.122-.733-.1-1.082-.663-1.082a1.6,1.6,0,0,0-1.274.785l-.663,4.311h-2.9Z",
    transform: "translate(-90.139 -210.655)",
    fill: "#2c6d8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M163.984,243.6h2.9l-.733,4.678,2.775-2.531H172.5l-3.561,3.142,2.863,4.224h-3.648l-2.2-3.421h-.035l-.524,3.4h-2.9Z",
    transform: "translate(-134.136 -201.08)",
    fill: "#2c6d8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M222.766,243.6H226.1l-1.466,9.513H221.3Z",
    transform: "translate(-182.672 -201.08)",
    fill: "#2c6d8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M251.084,243.6h4.765c3.683,0,4.748,2.671,4.4,4.887a5.275,5.275,0,0,1-5.271,4.626H249.6Zm3.09,7.244a2.547,2.547,0,0,0,2.775-2.5c.192-1.257-.192-2.5-1.99-2.5h-.89l-.768,4.992Z",
    transform: "translate(-206.033 -201.08)",
    fill: "#2c6d8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M129.927,0H116.05L114.2,11.747h2.356a3.614,3.614,0,0,0,3.037-1.449,1.4,1.4,0,0,0,.244-.751,1.416,1.416,0,0,0-.663-1.1,2.348,2.348,0,0,1-1.1-1.9,1.41,1.41,0,0,1,.017-.279c.192-1.239,1.868-2.583,4.084-2.583a4.254,4.254,0,0,1,2.95.89,2.052,2.052,0,0,1,.593,1.972,3.869,3.869,0,0,1-1.588,1.99c-1.344.943-1.169,1.763-1.082,2.007a2.43,2.43,0,0,0,2.164,1.2h3.6v.017c4.887.035,7.506,2.287,6.685,7.523-.768,4.87-4.5,6.964-8.954,7l-1.763,11.241h2.6c10.979,0,19.951-7.052,21.714-18.188C151.274,5.516,142.494,0,129.927,0",
    transform: "translate(-94.267 0)",
    fill: "#2c6d8f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankidLogo);
export default __webpack_public_path__ + "static/media/bankid_logo.5fa3021e8b7734b2d124a983eb8be4d5.svg";
export { ForwardRef as ReactComponent };